/* global axios */
import ApiClient from '../ApiClient';

class CrmStagesAPI extends ApiClient {
  constructor() {
    super('crm/stages', { accountScoped: true });
  }

  // Stages are nested under pipelines.
  // /api/v1/accounts/:id/crm/pipelines/:pipeline_id/stages
  list(pipelineId) {
    return axios.get(`${this.baseUrl()}/crm/pipelines/${pipelineId}/stages`);
  }

  create(pipelineId, stage) {
    return axios.post(
      `${this.baseUrl()}/crm/pipelines/${pipelineId}/stages`,
      { stage }
    );
  }

  update(pipelineId, stageId, stage) {
    return axios.patch(
      `${this.baseUrl()}/crm/pipelines/${pipelineId}/stages/${stageId}`,
      { stage }
    );
  }

  delete(pipelineId, stageId) {
    return axios.delete(
      `${this.baseUrl()}/crm/pipelines/${pipelineId}/stages/${stageId}`
    );
  }

  // Move all active cards from one stage to another (same pipeline).
  // Used by the UI before destroy when stage is not empty.
  moveCards(pipelineId, sourceStageId, targetStageId) {
    return axios.post(
      `${this.baseUrl()}/crm/pipelines/${pipelineId}/stages/${sourceStageId}/move_cards`,
      { target_stage_id: targetStageId }
    );
  }
}

export default new CrmStagesAPI();
